import Api from 'services/api';
import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';
import { stopNetHyperDX, startNetHyperDX } from 'services/hyperdx';

export const getSession = () => {
  return new Promise((resolve, reject) => {
    Api.get('/sessions', {
      withCredentials: true,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getRequestSession = (request_user_token) => {
  return new Promise((resolve, reject) => {
    Api.get('/request_sessions', { params: { token: request_user_token } })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteSession = () => {
  return new Promise((resolve, reject) => {
    Api.delete('/sessions')
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createPasswordReset = (user, captcha) => {
  return new Promise((resolve, reject) => {
    Api.post('/password_resets', { user, captcha })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updatePasswordReset = (user, captcha) => {
  return new Promise((resolve, reject) => {
    stopNetHyperDX();
    Api.put('/password_resets', { user, captcha })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      })
      .finally(() => startNetHyperDX());
  });
};

export const createSession = (attributes, captcha, temporaryIdentity) => {
  return new Promise((resolve, reject) => {
    stopNetHyperDX();
    Api.post(
      '/sessions',
      omitBy(
        {
          session: {
            ...attributes,
            otp: attributes.otp,
          },
          captcha,
          temporary_identity_id: temporaryIdentity ? temporaryIdentity.id : null,
        },
        isEmpty,
      ),
    )
      .then((response) => {
        if (response.status === 499) {
          resolve(response);
          return;
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      })
      .finally(() => startNetHyperDX());
  });
};

export const createUserRegistration = (userAttributes, accountId, hasReadGeneralConditions, captcha, temporary_identity_id) => {
  return new Promise((resolve, reject) => {
    stopNetHyperDX();
    Api.post(
      '/user_registration',
      omitBy(
        {
          user: { ...userAttributes, account_id: accountId },
          has_read_general_conditions: hasReadGeneralConditions,
          captcha,
          temporary_identity_id,
        },
        isEmpty(),
      ),
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      })
      .finally(() => startNetHyperDX());
  });
};

export const createRegistration = (userAttributes, accountAttributes, hasReadGeneralConditions, captcha, temporary_identity_id) => {
  return new Promise((resolve, reject) => {
    stopNetHyperDX();
    Api.post(
      '/registration',
      omitBy(
        {
          user: userAttributes,
          account: accountAttributes,
          has_read_general_conditions: hasReadGeneralConditions,
          captcha,
          temporary_identity_id,
        },
        isEmpty(),
      ),
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      })
      .finally(() => startNetHyperDX());
  });
};

export const checkEmailAvailability = (email, captcha) => {
  return new Promise((resolve, reject) => {
    Api.post('/email_availability', { user: { email }, captcha })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // 403 = bad captcha (ignore and resolve)
        // 400 = email taken
        reject(error);
      });
  });
};

export const getTemporarySessionByToken = (token) => {
  return new Promise((resolve, reject) => {
    Api.get('/temporary_sessions', { params: { token } })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
